export default function ({ store, redirect }) {
  if (
    store.state.auth.idToken &&
    store.state.auth.accessToken &&
    store.state.auth.refreshToken
  ) {
    return redirect('/dashboard/')
  }
}
